export const dateFormatStandard = 'DD-MM-YYYY';
export const dateFormatPretty = 'D MMMM YYYY';
export const dateFormatPrettyMinimizedYear = 'D MMMM YYYY'; // 12 May 2025
export const dateFormatPrettyFullYear = 'DD MMMM YYYY';
export const dateFormatPrettyFullDayMinimizedYear = 'dddd D MMMM, YY'; // Wednesday 12 May, 24
export const dateFormatCasual = 'dddd, D MMMM YY';
export const dateFormatCasualShort = 'ddd DD.MM.YY';
export const dateFormatCalendar = 'YYYY-MM-DD';
export const dateFormatFormKit = 'YYYY-MM-DD';
export const dateTimeFormatFormKit = 'YYYY-MM-DD HH:mm';
export const dateTimeFormatFullFormKit = 'YYYY-MM-DD HH:mm:ss';
export const dateTimeHoursFormatFull = 'HH:mm:ss';
export const timeFormatStandard = 'HH:mm';
export const dateTimeSortingFormat = 'YYYYMMDDHHmm';
export const dateTimeStandard = 'DD-MM-YYYYHH:mm';
export const defaultTimeSlotHour = 9;

export enum DateTimeSortingEnum {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year'
}
